module.exports = __webpack_public_path__ + "static/logoIFSblackV2-e139d23272c1df9f08c610177e77518b.png";